export const dashboardLocale = (language) => language === "sq" ? "sq-AL" : "en-US";

const MONTHS_SQ = Object.freeze([
  "janar", "shkurt", "mars", "prill", "maj", "qershor",
  "korrik", "gusht", "shtator", "tetor", "nëntor", "dhjetor",
]);

const MONTHS_SHORT_SQ = Object.freeze([
  "Jan", "Shk", "Mar", "Pri", "Maj", "Qer",
  "Kor", "Gus", "Sht", "Tet", "Nën", "Dhj",
]);

const WEEKDAYS_SQ = Object.freeze([
  "e diel", "e hënë", "e martë", "e mërkurë", "e enjte", "e premte", "e shtunë",
]);

export const dashboardPeriod = (now = new Date(), language = "en") => language === "sq"
  ? MONTHS_SQ[now.getMonth()]
  : new Intl.DateTimeFormat(dashboardLocale(language), { month: "long" }).format(now);

export const dashboardMonthShort = (now = new Date(), language = "en") => language === "sq"
  ? MONTHS_SHORT_SQ[now.getMonth()]
  : new Intl.DateTimeFormat(dashboardLocale(language), { month: "short" }).format(now);

export const dashboardDate = (now = new Date(), language = "en") => language === "sq"
  ? `${WEEKDAYS_SQ[now.getDay()]}, ${now.getDate()} ${MONTHS_SQ[now.getMonth()]}`
  : new Intl.DateTimeFormat(dashboardLocale(language), {
    weekday: "long",
    month: "long",
    day: "numeric",
  }).format(now);

export const albanianInvoiceCountText = (kind, count, displayedCount = String(count)) => {
  const singular = Number(count) === 1;
  if (kind === "settled") return singular
    ? `${displayedCount} faturë e paguar këtë muaj`
    : `${displayedCount} fatura të paguara këtë muaj`;
  if (kind === "open") return singular
    ? `Në ${displayedCount} faturë të hapur`
    : `Në ${displayedCount} fatura të hapura`;
  if (kind === "follow-up") return singular
    ? `${displayedCount} faturë kërkon përcjellje këtë javë.`
    : `${displayedCount} fatura kërkojnë përcjellje këtë javë.`;
  return singular
    ? `${displayedCount} faturë kërkon vëmendje`
    : `${displayedCount} fatura kërkojnë vëmendje`;
};
